export type ChinaGirlsWeightPercentileKey = 'p3' | 'p10' | 'p25' | 'p50' | 'p75' | 'p90' | 'p97';

export interface ChinaGirlsWeightPercentilePoint {
  month: number;
  p3: number;
  p10: number;
  p25: number;
  p50: number;
  p75: number;
  p90: number;
  p97: number;
}

export const CHINA_GIRLS_WEIGHT_STANDARD = {
  standard: 'WS/T 423—2022',
  table: 'A.2',
  title: '7岁以下女童年龄别体重的百分位数值',
  effectiveDate: '2023-03-01',
  sourceUrl: 'https://www.nhc.gov.cn/fzs/c100048/202211/5001d7cf57774770a1d49c1df46a291f/files/1733125082501_81468.pdf',
} as const;

// Official kilogram values for girls, birth through 24 completed months.
// Source: China National Health Commission, WS/T 423—2022, Table A.2.
export const CHINA_GIRLS_WEIGHT_FOR_AGE: readonly ChinaGirlsWeightPercentilePoint[] = [
  { month: 0, p3: 2.7, p10: 2.9, p25: 3.1, p50: 3.3, p75: 3.6, p90: 3.8, p97: 4.1 },
  { month: 1, p3: 3.5, p10: 3.7, p25: 4.0, p50: 4.3, p75: 4.6, p90: 4.9, p97: 5.3 },
  { month: 2, p3: 4.4, p10: 4.7, p25: 5.0, p50: 5.4, p75: 5.8, p90: 6.2, p97: 6.6 },
  { month: 3, p3: 5.1, p10: 5.4, p25: 5.8, p50: 6.2, p75: 6.7, p90: 7.2, p97: 7.6 },
  { month: 4, p3: 5.6, p10: 6.0, p25: 6.4, p50: 6.9, p75: 7.4, p90: 7.9, p97: 8.4 },
  { month: 5, p3: 6.0, p10: 6.4, p25: 6.9, p50: 7.4, p75: 7.9, p90: 8.5, p97: 9.1 },
  { month: 6, p3: 6.4, p10: 6.8, p25: 7.2, p50: 7.8, p75: 8.4, p90: 9.0, p97: 9.6 },
  { month: 7, p3: 6.7, p10: 7.1, p25: 7.6, p50: 8.1, p75: 8.8, p90: 9.4, p97: 10.0 },
  { month: 8, p3: 6.9, p10: 7.4, p25: 7.9, p50: 8.4, p75: 9.1, p90: 9.7, p97: 10.4 },
  { month: 9, p3: 7.2, p10: 7.6, p25: 8.1, p50: 8.7, p75: 9.4, p90: 10.0, p97: 10.8 },
  { month: 10, p3: 7.4, p10: 7.8, p25: 8.3, p50: 9.0, p75: 9.6, p90: 10.3, p97: 11.1 },
  { month: 11, p3: 7.6, p10: 8.0, p25: 8.6, p50: 9.2, p75: 9.9, p90: 10.6, p97: 11.4 },
  { month: 12, p3: 7.7, p10: 8.2, p25: 8.8, p50: 9.4, p75: 10.1, p90: 10.9, p97: 11.6 },
  { month: 13, p3: 7.9, p10: 8.4, p25: 9.0, p50: 9.6, p75: 10.4, p90: 11.1, p97: 11.9 },
  { month: 14, p3: 8.1, p10: 8.6, p25: 9.2, p50: 9.8, p75: 10.6, p90: 11.3, p97: 12.2 },
  { month: 15, p3: 8.3, p10: 8.8, p25: 9.3, p50: 10.0, p75: 10.8, p90: 11.6, p97: 12.4 },
  { month: 16, p3: 8.4, p10: 9.0, p25: 9.5, p50: 10.3, p75: 11.0, p90: 11.8, p97: 12.7 },
  { month: 17, p3: 8.6, p10: 9.1, p25: 9.7, p50: 10.5, p75: 11.3, p90: 12.1, p97: 12.9 },
  { month: 18, p3: 8.8, p10: 9.3, p25: 9.9, p50: 10.7, p75: 11.5, p90: 12.3, p97: 13.2 },
  { month: 19, p3: 9.0, p10: 9.5, p25: 10.1, p50: 10.9, p75: 11.7, p90: 12.6, p97: 13.5 },
  { month: 20, p3: 9.1, p10: 9.7, p25: 10.3, p50: 11.1, p75: 12.0, p90: 12.8, p97: 13.8 },
  { month: 21, p3: 9.3, p10: 9.9, p25: 10.5, p50: 11.3, p75: 12.2, p90: 13.1, p97: 14.0 },
  { month: 22, p3: 9.5, p10: 10.1, p25: 10.7, p50: 11.5, p75: 12.4, p90: 13.3, p97: 14.3 },
  { month: 23, p3: 9.7, p10: 10.3, p25: 10.9, p50: 11.7, p75: 12.6, p90: 13.6, p97: 14.6 },
  { month: 24, p3: 9.8, p10: 10.4, p25: 11.1, p50: 11.9, p75: 12.9, p90: 13.8, p97: 14.8 },
];
